export default {
  getlan: (state) => {
    return state.lan
  },
  getcurrentlanguage: (state) => {
    return state.currentlanguage
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js